export enum NotificationType {
  Octomize = 1,
}
